import React from 'react';
import styled from 'styled-components';
import { observer } from 'mobx-react-lite';
import { useRootStore } from '../../App';
import { ChatSubmitButton } from '../molecules/ChatSubmitButton';
import { FileUploadButton } from './FileUploadButton';
import { ChatInput } from '../molecules/ChatInput';
import { Attachment } from '../molecules/Attachment';
import { RatClickTracker } from '../molecules/RatClickTracker';
import { NarrowAlertFormDiv, MessageSpan, AlertIconSpan } from '../atoms';

const BaseStyledDiv = styled.div`
  position: fixed;
  position: sticky;
  position: -webkit-sticky;
  bottom: 0px;
  padding-top: 6px;
  background: #ffffff;
  z-index: 2;
  padding-bottom: env(safe-area-inset-bottom);
  display: inline;

  box-shadow: 0 2px 4px 2px rgba(0, 0, 0, 0.2);
  ${(props: { isNewInquiryPage: boolean }) =>
    props.isNewInquiryPage
      ? `

  -webkit-opacity: 0;
  opacity: 0;

  -webkit-transform: translateY(0%);
  transform: translateY(0%);

  -webkit-animation: webkit-slide-in 0.2s forwards;
  animation: slide-in 0.2s forwards;

  -webkit-animation-delay: 1s;
  animation-delay: 1s;

  @keyframes slide-in {
    0% {
      transform: translateY(100%);
    }
    100% {
      transform: translateY(0%);
      opacity: 100;
    }
  }

  @-webkit-keyframes webkit-slide-in {
    0% {
      transform: translateY(100%);
    }
    100% {
      -webkit-transform: translateY(0%);
      -webkit-opacity: 100;
    }
  }`
      : ''};
`;

const MainStyledDiv = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
`;

const ButtonStyledImg = styled.img`
  margin-right: 0.5%;
  cursor: pointer;
`;

const AlertMessageSpan = styled.span`
  font-size: 12px;
  line-height: 15px;
  color: #ff3939;
  animation: 0.4s show_alert;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: center;
  align-items: center;
  width: 89%;
  float: left;
`;

const ErrorSection = styled.section`
  font-size: 12px;
  line-height: 15px;
  color: #ff3939;
  animation: 0.4s show_alert;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: center;
  align-items: center;
`;

export const ChatInputForm = observer(() => {
  const placeHolder = 'お問い合わせ内容を入力してください';
  const root = useRootStore();
  const { isWide } = root.layoutStore;
  const {
    attachments,
    inputMessage,
    fileUploadDocumentRequest,
    onSubmit,
    setInputMessage,
    onDeleteAttachFile,
    validationMessage,
    warningMessage,
    onClickAlertClose,
    isFileUploading,
  } = root.chatInputStore;
  const { isFaqUnresolved } = root.faqStore;

  const { validateActiveInquiryId } = root.inquiryStore;

  const isChatInputDisabled = (function () {
    if (!validateActiveInquiryId() && isFaqUnresolved && !isFileUploading) {
      return false;
    }
    return !validateActiveInquiryId() || isFileUploading;
  })();
  const errors = validationMessage.map((message, index) => {
    return (
      <NarrowAlertFormDiv key={`validationMessage-${index}`}>
        <AlertIconSpan />
        <MessageSpan className={'errorMessage'}> {message} </MessageSpan>
        <ButtonStyledImg
          alt="close button"
          src="/images/close_button_red_small.png"
          onClick={() => onClickAlertClose(index)}
        />
      </NarrowAlertFormDiv>
    );
  });

  const warnings = warningMessage.map((error: string) => (
    <ErrorSection key={error}>
      <AlertIconSpan />
      <AlertMessageSpan className={'warningMessage'}>{error}</AlertMessageSpan>
    </ErrorSection>
  ));

  return isWide ? (
    <div>
      <>
        <div>
          <ChatInput
            disabled={isChatInputDisabled}
            isWide={isWide}
            onChange={(event: React.ChangeEvent<HTMLTextAreaElement>) => {
              setInputMessage(event.target.value);
            }}
            placeholder={placeHolder}
            value={inputMessage}
          />
        </div>
        {warnings}
        {errors}
        <FileUploadButton
          disabled={isChatInputDisabled}
          isWide={isWide}
          onClick={fileUploadDocumentRequest}
        />
      </>
      <RatClickTracker componentId={'send_message'}>
        <ChatSubmitButton
          disabled={isChatInputDisabled}
          isWide={isWide}
          onSubmit={onSubmit}
        />
      </RatClickTracker>
    </div>
  ) : (
    <BaseStyledDiv isNewInquiryPage={true}>
      {warnings}
      {errors}
      <section>
        {attachments.map((attachment, index) => {
          return (
            <Attachment
              key={`attachments-${index}`}
              attachment={attachment}
              isWide={isWide}
              onClick={onDeleteAttachFile}
            />
          );
        })}
      </section>
      <MainStyledDiv>
        <>
          <FileUploadButton
            disabled={isChatInputDisabled}
            isWide={isWide}
            onClick={fileUploadDocumentRequest}
          />
          <ChatInput
            disabled={isChatInputDisabled}
            isWide={isWide}
            onChange={(event: React.ChangeEvent<HTMLTextAreaElement>) => {
              setInputMessage(event.target.value);
            }}
            placeholder={placeHolder}
            value={inputMessage}
          />
        </>
        <ChatSubmitButton
          disabled={isChatInputDisabled}
          isWide={isWide}
          onSubmit={onSubmit}
        />
      </MainStyledDiv>
    </BaseStyledDiv>
  );
});
